<template>
  <f-box 
    class="role-list-item margin-bottom-3"
    grid
  > 
    <div class="is-col-2 is-overflow-hidden p-left-5">
      <p class="is-ellipsis">
        <small>
          <router-link 
            :to="{ 
              name: 'role-edit-infos', 
              params: { role_id: role._id } 
            }"
            class="color-text"
          >
            {{ role.name }}
          </router-link>
        </small>
      </p>
    </div>

     <div class="is-col-2 is-overflow-hidden">
      <p class="is-ellipsis">
        <small>
          <b>
            {{ role.slug }}
          </b>
        </small>
      </p>
    </div>

    <div class="is-col-6 is-overflow-hidden">
      <p class="is-ellipsis">
        <small>
          {{ permissions }}
        </small>
      </p>
    </div>

    <div class="is-col-2">
      <p>
        <small>
          {{ formatDate(role.createdAt) }}
        </small>
      </p>
    </div>
  </f-box>
</template>

<script>
  import { ref, computed, watch } from 'vue'
  import toFixed from '@utils/toFixed'
  import toThousand from '@utils/toThousand'
  import formatDate from '@utils/formatDate'
  
  export default {
    props: {
      role: {
        type: Object,
        required: true,
      },

      selectable: {
        type: Boolean, 
        default: true,
      },

      isSelected: {
        type: Boolean, 
        default: false,
      },
    },

    setup (props, context) {
      const selected = ref(!!props.selected)
      const permissions = computed(() => {
        const firstPermissions = props.role.permissions.slice(0, 6).join(', ') 

        return props.role.permissions.length > 6 
          ? `${firstPermissions} (+${props.role.permissions.length - 6})`
          : firstPermissions
      })

      function toggleSelection () {
        context.emit('toggle-selection', props.role._id, !!props.isSelected)
      }

      watch(() => props.isSelected, newValue => {
        if (newValue != selected.value) {
          selected.value = !!newValue
        }
      })

      return {
        permissions,
        selected,
        toggleSelection,
        formatDate,
      }
    }
  }
</script>

<style lang="scss">
  .role-list-item {
    padding: 0.45rem 1rem 0.45rem 1rem;
  }
</style>